import { isPast, parseISO } from 'date-fns'
import getImageRenditions from '../../../utils/getImageRenditions'
import getEpisodeUrl from '../../../utils/getEpisodeUrl'
import { readCookies, parseRemainingTimeString } from '../../../utils/stopResume'

async function getFeaturedEpisode({ programmeData, playerApi, req }) {
  let guid
  let path = '/episodes'
  let label
  let progress = 0
  let duration

  const watchedEpisodes = readCookies(req)
  if (watchedEpisodes.length) {
    // do we have an episode we haven't finished watching?
    const episode = watchedEpisodes
      // don't show episodes that are no longer available
      .filter(item => !isPast(parseISO(item?.exp)))
      // we don't store the programme's GUID in stop/resume so check against the name
      .find(item => item?.prg === programmeData?.name)
    if (episode) {
      const { id, pos, dur } = episode
      guid = id
      label = 'Continue watching'
      progress = pos / dur
      duration = `${parseRemainingTimeString(dur - pos)} remaining`
    }
  }

  if (!guid) {
    if (programmeData?.featuredEpisode?.guid) {
      // if not, get the featured episode, if available
      ({ guid, label } = programmeData?.featuredEpisode)
      // if no featured episode, check for featured shortform
    } else if (programmeData?.featuredShortform?.guid) {
      ({ guid } = programmeData?.featuredShortform)
      path = '/shortform'
    }
  }

  if (!guid) return null

  try {
    const { results } = await playerApi({
      path: `${path}/${guid}`,
      query: {
        groupToken: '0071',
      },
    })

    const type = path === '/episodes' ? 'episode' : 'video'

    return extractFeaturedEpisodeData({
      episode: results,
      label,
      type,
      progress,
      duration,
      programmeGuid: programmeData?.guid,
    })
  } catch {
    return null
  }
}

function extractFeaturedEpisodeData({
  episode,
  label,
  type,
  progress,
  duration,
  programmeGuid,
}) {
  const link = getEpisodeUrl({
    episodeId: episode.id,
    programmeGuid: programmeGuid || episode?.programme?.guid,
    path: type,
  })
  return {
    link,
    label,
    summary: episode?.summary,
    title: episode?.title,
    availableUntil: episode?.availability?.until,
    image: getImageRenditions(
      episode?.images?.[0]._filepath,
      ['225x127', '365x205', '460x259', '800x450']
    ),
    duration: duration || episode?.video?._duration,
    hasSubtitles: Boolean(episode?._subtitles),
    hasGuidanceText: Boolean(episode?.guidanceText),
    hasInfoText: Boolean(episode?.informationText),
    hasCompetitionText: Boolean(episode?.competitionText),
    audioDescribed: Boolean(episode?.audioDescribedGuid),
    visuallySigned: Boolean(episode?.visuallySignedGuid),
    programmeName: episode.programme?.name,
    informationText: episode?.informationText,
    competitionText: episode?.competitionText,
    durationOverlay: true,
    progress,
  }
}

export default getFeaturedEpisode
